/**
 * A browser identifier is only a convenience. The Core decides whether a
 * server-provided session is eligible to resume; this function simply tries
 * the remembered id first, then the eligible fallback without creating data.
 */
export async function restoreCopilotSession(
  rememberedId: string | null,
  eligibleId: string | null,
  load: (sessionId: string) => Promise<unknown>,
): Promise<string | null> {
  const candidates = [...new Set([rememberedId, eligibleId].filter((id): id is string => Boolean(id)))];
  for (const sessionId of candidates) {
    try {
      await load(sessionId);
      return sessionId;
    } catch {
      // A closed, expired or stale local id must not prevent server recovery.
    }
  }
  return null;
}
